var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatchActual = function SvgBatchActual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 14c-3.823 0-7-3.177-7-7 0-3.83 3.17-7 6.993-7C10.823 0 14 3.17 14 7c0 3.823-3.17 7-7 7m0-1.167A5.81 5.81 0 0 0 12.833 7c0-3.24-2.6-5.833-5.84-5.833A5.8 5.8 0 0 0 1.173 7 5.805 5.805 0 0 0 7 12.833M4.406 6.266c-.357 0-.597-.172-.597-.522s.226-.528.597-.528h5.168c.363 0 .59.178.59.528s-.24.522-.59.522zm0 2.532c-.357 0-.597-.172-.597-.515 0-.35.226-.528.597-.528h5.168c.363 0 .59.178.59.528 0 .343-.24.515-.59.515z"
  })));
};
export default SvgBatchActual;